import { useMemo } from 'react';
import { RadioGroupContext } from './RadioGroupContext.ts';

type Props = {
  name: string;
  children: React.ReactNode;
  value?: string | number;
  onChange?: (...event: Array<React.SyntheticEvent<HTMLInputElement>>) => void;
};

export function RadioGroup({ name, value: selectedValue, onChange, children }: Props) {
  const value = useMemo(() => ({ name, selectedValue, onChange }), [name, onChange, selectedValue]);
  return <RadioGroupContext value={value}>{children}</RadioGroupContext>;
}
